import { render, staticRenderFns } from "./limits-table.vue?vue&type=template&id=c26d81c6&"
import script from "./limits-table.vue?vue&type=script&lang=js&"
export * from "./limits-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c26d81c6')) {
      api.createRecord('c26d81c6', component.options)
    } else {
      api.reload('c26d81c6', component.options)
    }
    module.hot.accept("./limits-table.vue?vue&type=template&id=c26d81c6&", function () {
      api.rerender('c26d81c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/limits-table.vue"
export default component.exports